import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MplButton } from '../../atoms/MplButton';
import { MplErrorModal } from '../MplModal/MplErrorModal';

interface ModalProps {
	onClose: () => void;
	isOpen: boolean;
	errorTitle: string | undefined;
	errorDescription?: string | undefined;
}

export const SocialLoginErrorModal: FC<ModalProps> = ({
	onClose,
	isOpen,
	errorTitle,
	errorDescription,
}) => {
	const { t } = useTranslation('errors');
	return (
		<MplErrorModal
			testId="SocialLoginErrorModal-MplModal"
			open={isOpen}
			onClose={onClose}
			title={errorTitle}
			content={errorDescription}
			buttons={
				<MplButton
					fullWidth
					color="primaryButtonV2"
					testId="socialLogin-error-modal-button"
					onClick={onClose}
				>
					{t('button.close')}
				</MplButton>
			}
		/>
	);
};
